import { http } from "./http";
export type WorkspaceReference = {
  entityType:
    | "CANDIDATE"
    | "INSTRUCTOR"
    | "SECRETARY"
    | "LESSON"
    | "EXAM"
    | "VEHICLE"
    | "INVOICE"
    | "PAYMENT"
    | "RDVPERMIS_SLOT"
    | "DOCUMENT"
    | "TASK"
    | "NOTE"
    | "MEETING"
    | "BOARD";
  entityId: string;
};
export type ResolvedReference = WorkspaceReference &
  (
    | {
        available: true;
        label: string;
        href: string;
        fields?: { label: string; value: string }[];
      }
    | { available: false }
  );

const identity = ({
  entityType,
  entityId,
}: WorkspaceReference): WorkspaceReference => ({ entityType, entityId });
export const referencesApi = {
  related: async (reference: WorkspaceReference, page = 1) =>
    (
      await http.get<{ items: ResolvedReference[]; hasMore: boolean }>(
        "/v1/workspace/references/related",
        { params: { ...identity(reference), page } },
      )
    ).data,
  get: async (reference: WorkspaceReference) =>
    (
      await http.get<ResolvedReference>("/v1/workspace/references", {
        params: identity(reference),
      })
    ).data,
  search: async (
    search: string,
    entityType: WorkspaceReference["entityType"] = "CANDIDATE",
    page = 1,
  ) =>
    (
      await http.get<{ items: ResolvedReference[]; hasMore: boolean }>(
        "/v1/workspace/references/search",
        { params: { search, entityType, page } },
      )
    ).data,
  resolve: async (references: WorkspaceReference[]) => {
    const result = (
      await http.post<{ items: ResolvedReference[]; resolvedAt: string }>(
        "/v1/workspace/references/resolve",
        { references: references.map(identity) },
      )
    ).data;
    if (
      !Array.isArray(result?.items) ||
      result.items.length !== references.length ||
      result.items.some(
        (r, i) =>
          r.entityType !== references[i].entityType ||
          r.entityId !== references[i].entityId,
      )
    )
      throw new Error("Réponse de référence invalide.");
    return result;
  },
};
